import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\PromotionsController::index
* @see app/Http/Controllers/Admin/PromotionsController.php:16
* @route '/admin/promotions'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/promotions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PromotionsController::index
* @see app/Http/Controllers/Admin/PromotionsController.php:16
* @route '/admin/promotions'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PromotionsController::index
* @see app/Http/Controllers/Admin/PromotionsController.php:16
* @route '/admin/promotions'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::index
* @see app/Http/Controllers/Admin/PromotionsController.php:16
* @route '/admin/promotions'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::index
* @see app/Http/Controllers/Admin/PromotionsController.php:16
* @route '/admin/promotions'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::index
* @see app/Http/Controllers/Admin/PromotionsController.php:16
* @route '/admin/promotions'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::index
* @see app/Http/Controllers/Admin/PromotionsController.php:16
* @route '/admin/promotions'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\PromotionsController::create
* @see app/Http/Controllers/Admin/PromotionsController.php:25
* @route '/admin/promotions/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/promotions/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PromotionsController::create
* @see app/Http/Controllers/Admin/PromotionsController.php:25
* @route '/admin/promotions/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PromotionsController::create
* @see app/Http/Controllers/Admin/PromotionsController.php:25
* @route '/admin/promotions/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::create
* @see app/Http/Controllers/Admin/PromotionsController.php:25
* @route '/admin/promotions/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::create
* @see app/Http/Controllers/Admin/PromotionsController.php:25
* @route '/admin/promotions/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::create
* @see app/Http/Controllers/Admin/PromotionsController.php:25
* @route '/admin/promotions/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::create
* @see app/Http/Controllers/Admin/PromotionsController.php:25
* @route '/admin/promotions/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\PromotionsController::store
* @see app/Http/Controllers/Admin/PromotionsController.php:32
* @route '/admin/promotions'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/promotions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\PromotionsController::store
* @see app/Http/Controllers/Admin/PromotionsController.php:32
* @route '/admin/promotions'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PromotionsController::store
* @see app/Http/Controllers/Admin/PromotionsController.php:32
* @route '/admin/promotions'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::store
* @see app/Http/Controllers/Admin/PromotionsController.php:32
* @route '/admin/promotions'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::store
* @see app/Http/Controllers/Admin/PromotionsController.php:32
* @route '/admin/promotions'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\PromotionsController::edit
* @see app/Http/Controllers/Admin/PromotionsController.php:61
* @route '/admin/promotions/{promotion}/edit'
*/
export const edit = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/promotions/{promotion}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PromotionsController::edit
* @see app/Http/Controllers/Admin/PromotionsController.php:61
* @route '/admin/promotions/{promotion}/edit'
*/
edit.url = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { promotion: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { promotion: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            promotion: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        promotion: typeof args.promotion === 'object'
        ? args.promotion.id
        : args.promotion,
    }

    return edit.definition.url
            .replace('{promotion}', parsedArgs.promotion.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PromotionsController::edit
* @see app/Http/Controllers/Admin/PromotionsController.php:61
* @route '/admin/promotions/{promotion}/edit'
*/
edit.get = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::edit
* @see app/Http/Controllers/Admin/PromotionsController.php:61
* @route '/admin/promotions/{promotion}/edit'
*/
edit.head = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::edit
* @see app/Http/Controllers/Admin/PromotionsController.php:61
* @route '/admin/promotions/{promotion}/edit'
*/
const editForm = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::edit
* @see app/Http/Controllers/Admin/PromotionsController.php:61
* @route '/admin/promotions/{promotion}/edit'
*/
editForm.get = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::edit
* @see app/Http/Controllers/Admin/PromotionsController.php:61
* @route '/admin/promotions/{promotion}/edit'
*/
editForm.head = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\PromotionsController::update
* @see app/Http/Controllers/Admin/PromotionsController.php:69
* @route '/admin/promotions/{promotion}'
*/
export const update = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/promotions/{promotion}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\PromotionsController::update
* @see app/Http/Controllers/Admin/PromotionsController.php:69
* @route '/admin/promotions/{promotion}'
*/
update.url = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { promotion: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { promotion: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            promotion: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        promotion: typeof args.promotion === 'object'
        ? args.promotion.id
        : args.promotion,
    }

    return update.definition.url
            .replace('{promotion}', parsedArgs.promotion.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PromotionsController::update
* @see app/Http/Controllers/Admin/PromotionsController.php:69
* @route '/admin/promotions/{promotion}'
*/
update.put = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::update
* @see app/Http/Controllers/Admin/PromotionsController.php:69
* @route '/admin/promotions/{promotion}'
*/
const updateForm = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::update
* @see app/Http/Controllers/Admin/PromotionsController.php:69
* @route '/admin/promotions/{promotion}'
*/
updateForm.put = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\PromotionsController::destroy
* @see app/Http/Controllers/Admin/PromotionsController.php:96
* @route '/admin/promotions/{promotion}'
*/
export const destroy = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/promotions/{promotion}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\PromotionsController::destroy
* @see app/Http/Controllers/Admin/PromotionsController.php:96
* @route '/admin/promotions/{promotion}'
*/
destroy.url = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { promotion: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { promotion: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            promotion: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        promotion: typeof args.promotion === 'object'
        ? args.promotion.id
        : args.promotion,
    }

    return destroy.definition.url
            .replace('{promotion}', parsedArgs.promotion.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PromotionsController::destroy
* @see app/Http/Controllers/Admin/PromotionsController.php:96
* @route '/admin/promotions/{promotion}'
*/
destroy.delete = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::destroy
* @see app/Http/Controllers/Admin/PromotionsController.php:96
* @route '/admin/promotions/{promotion}'
*/
const destroyForm = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\PromotionsController::destroy
* @see app/Http/Controllers/Admin/PromotionsController.php:96
* @route '/admin/promotions/{promotion}'
*/
destroyForm.delete = (args: { promotion: string | number | { id: string | number } } | [promotion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const promotions = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default promotions